/**
 * Common styles and utilities for DFP plugin components
 */

/**
 * Common scrollbar styles used across multiple components
 * Note: These are theme-neutral and work well with both light and dark themes
 */
export const scrollbarStyles = {
  '&::-webkit-scrollbar': {
    width: '12px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'rgba(128, 128, 128, 0.1)',
    borderRadius: '10px',
    border: '1px solid rgba(128, 128, 128, 0.2)',
    marginBottom: '0px',
    marginTop: '0px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: 'linear-gradient(180deg, #667eea 0%, #764ba2 100%)',
    borderRadius: '10px',
    border: '1px solid rgba(128, 128, 128, 0.3)',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
    minHeight: '60px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: 'linear-gradient(180deg, #5a6fd8 0%, #6a4190 100%)',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
  },
  '&::-webkit-scrollbar-corner': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-button': {
    display: 'none',
  },
};

/**
 * Common color constants
 */
export const colors = {
  primary: '#ab47bc',
  primaryHover: '#9c27b0',
  white: '#ffffff',
  
  // Grayscale
  gray666: '#666',
  grayBorder: '#e0e0e0',
  grayNeutral: '#9e9e9e',
  
  // Status colors
  success: '#2e7d32',
  warning: '#f57c00',
  error: '#d32f2f',
  errorDark: '#c62828',
  errorBackground: '#ffebee',
  errorBorder: '#f44336',
  
  // Transparent whites
  transparentWhite: 'rgba(255, 255, 255, 0.1)',
  transparentWhiteBorder: 'rgba(255, 255, 255, 0.2)',
  transparentWhiteThick: 'rgba(255, 255, 255, 0.3)',
  
  // Gradients
  gradientPrimary: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  gradientScroll: 'linear-gradient(180deg, #667eea 0%, #764ba2 100%)',
  gradientScrollHover: 'linear-gradient(180deg, #5a6fd8 0%, #6a4190 100%)',
} as const;

/**
 * Utility function to get badge color based on percentage
 */
export const getBadgeColor = (percentage: number): string => {
  if (percentage === 0) return colors.grayNeutral;
  if (percentage <= 50) return colors.error;
  if (percentage <= 80) return colors.warning;
  return colors.success;
};

/**
 * Common shadow styles
 */
export const shadows = {
  card: '0 2px 4px rgba(0, 0, 0, 0.1)',
  cardHover: '0 4px 8px rgba(0, 0, 0, 0.15)',
  scrollbar: '0 2px 4px rgba(0, 0, 0, 0.2)',
  scrollbarHover: '0 4px 8px rgba(0, 0, 0, 0.3)',
} as const;

/**
 * Common inline styles for frequent use
 */
export const commonInlineStyles = {
  notAvailable: { color: colors.gray666, fontStyle: 'italic' as const },
  marginBottom25: { marginBottom: 25 },
  marginBottom16: { marginBottom: 16 },
  marginBottom20: { marginBottom: 20 },
  padding8x0: { padding: '8px 0' },
  padding4x0: { padding: '4px 0' },
} as const;


